import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import {
  hasKeycloakCallbackHash,
  resolveKeycloakCallbackHash,
} from '@/services/keycloakRedirect';
import allRoutes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    document.getElementById('app')
      .scrollIntoView({ behavior: 'smooth' });
  },
});

/**
 * Apply beforeEnter guard to the routes.
 *
 * @param  {Array} routes
 * @param  {Function} beforeEnter
 * @return {Array}
 */
function applyBeforeEnter(routes, beforeEnter) {
  return routes.map((route) => ({ ...route, beforeEnter }));
}

/**
 * Make sure user is logged in
 *
 * @param  {Array} routes
 * @return {Array}
 */
function authGuard(routes) {
  return applyBeforeEnter(routes, (to, from, next) => {
    if (hasKeycloakCallbackHash()) {
      resolveKeycloakCallbackHash(next);
      return;
    }

    if (!store.getters['auth/isAuthenticated']) {
      if (store.getters['auth/isAuthenticating']) {
        next(false);
        return;
      }

      store.dispatch('auth/login');
      next(false);
      return;
    }

    next();
  });
}

/**
 * Guest routes can be access by anyone
 *
 * @param  {Array} routes
 * @return {Array}
 */
function guestGuard(routes) {
  return applyBeforeEnter(routes, (to, from, next) => {
    if (hasKeycloakCallbackHash()) {
      resolveKeycloakCallbackHash(next);
      return;
    }

    next();
  });
}

allRoutes({ authGuard, guestGuard }).forEach((route) => {
  router.addRoute(route);
});

router.beforeEach((to, from, next) => {
  const maintenanceEnabled = store.getters['maintenance/isEnabled'];
  if (maintenanceEnabled && to.name !== 'Maintenance') {
    next({ name: 'Maintenance', replace: true });
    return;
  }

  if (!maintenanceEnabled && to.name === 'Maintenance') {
    next({ name: 'Dashboard', replace: true });
    return;
  }

  next();
});

export default router;
